import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProfilePage from "../pages/Profile/Profile";
import Login from "../pages/authentication/Login";
import SignUp from "../pages/authentication/SignUp";
import ProtectedRoute from "../Hooks/protectedRoutes";
import MembershipForm from "../forms/Membership_Application_Form";
import Layout from "../layouts/Layout";
import Dashboard from "../pages/home/Dashboard";
import MemberCard from "../pages/member/member";
import DataTableComponent from "../pages/datatable/DataTableComponent";
import Membership from "../pages/membership/Membership";
import Business_Add from "../components/Business_Impact/Business_Add";
import New_Request from "../components/Freight_Request/New_Request";
import Sent_Request from "../components/Freight_Request/Sent_Request";
import Receive_Request from "../components/Freight_Request/Receive_Request";               
import Accept_Request from "../components/Freight_Request/Accept_Request";
import TableComponent from "../pages/Directory/userList";
import MemberTimeline from "../pages/Timeline/Feeds";
import NewsReadPage from "../pages/News/NewsRead";
import NewsPage from "../pages/News/AllNews";
import PhotoGallery from "../Gallary/photos/Photo";
import AlbumsCard from "../Gallary/Albums/AlbumsCards";
import AlbumGallery from "../Gallary/Albums/Albums";
import VideosGallery from "../Gallary/Videos/video";
import EventsMenu from "../pages/Events/EventsMenu";
import EventCards from "../pages/Events/EventsCards";
import Events from "../pages/Events/Events";
import EventRegistrationForm from "../pages/Events/EventRegistrationForm";
import Lodderr from "../components/Lodder/Lodder";
import Certificates from "../pages/certificates/Certtificates";
import OtherProfile from "../pages/otherMembersProfile/otherMemberProfile";
import Chat from "../pages/Chat/Chat";
import ThankYou from "../pages/thankyou/Thankyou";
import BusinessWalletList from "../components/Business_Impact/Buisness_imapct_list";
import RecntMember from "../pages/Directory/RecntMember";
import WithdrawalForm from "../components/Business_Impact/RequestWithdrawal";
import Invoice from "../components/Invoice/Invoice";
import InvoiceList from "../components/Invoice/invoiceList";
import AddBuisness from "../components/Business_Impact/AddBuisness";
import Activeuser from "../pages/Directory/ActiveUsers";
import Help from "../pages/Help/Help";
import MemberinCountry from "../pages/Directory/memberinCountry";
import MyChatbot from "../components/chatbot/MyChatbot";
import BranchManagement from "../pages/Profile/BranchManagement";
import InvoicesPage from "../pages/invoice/invoice";
import NotFound from "../pages/NotFound/NotFound";
import SSOHandler from "../pages/SSOHandler/SSOHandler";
import ScrollToTop from "../Hooks/ScrollToTop";


export default function Router() {
  return (
    <BrowserRouter basename="/GFG_/Frontend">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path="/signUp" element={<SignUp />}/>
        <Route path="/thankyou" element={<ThankYou />}/>
        <Route path="/SSOHandler" element={<SSOHandler />}/>
        <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>}/>
        <Route path="/MembershipForm" element={<Layout><DataTableComponent /></Layout>}/>
        <Route path="/Membership" element={<Layout><Membership /></Layout>}/>
        <Route path="/Business_impact" element={<Layout><AddBuisness /></Layout>}/>  
        <Route path="/Businessimpact" element={<Layout><BusinessWalletList /></Layout>}/> 
        <Route path="/Profile" element={<Layout><ProfilePage /></Layout>}/>
        <Route path="/Membership_Application_Form" element={<Layout><MembershipForm /></Layout>}/>
        <Route path="/new_request" element={<Layout><New_Request /></Layout>}/>
        <Route path="/sent_request" element={<Layout><Sent_Request /></Layout>}/>
        <Route path="/receive_request" element={<Layout><Receive_Request /></Layout>}/>
        <Route path="/accept_request" element={<Layout><Accept_Request /></Layout>}/>
        <Route path="/member" element={<Layout><MemberCard /></Layout>}/>
        <Route path="/Timeline" element={<Layout><MemberTimeline /></Layout>}/>
        <Route path="/user" element={<Layout><TableComponent /></Layout>}/>
        <Route path="/newsArticle" element={<Layout><NewsReadPage /></Layout>}/>
        <Route path="/news" element={<Layout><NewsPage /></Layout>}/>
        <Route path="/photos-gallery" element={<Layout><PhotoGallery /></Layout>}/>
        <Route path="/albumCard" element={<Layout><AlbumsCard /></Layout>}/>
        <Route path="/albums-gallery" element={<Layout><AlbumGallery /></Layout>}/>
        <Route path="/videos-gallery" element={<Layout><VideosGallery /></Layout>}/>
        <Route path="/EventsMenu" element={<Layout><EventsMenu /></Layout>}/>
        <Route path="/EventsCards" element={<Layout><EventCards /></Layout>}/>
        <Route path="/Events" element={<Layout><Events /></Layout>}/>
        <Route path="/EventRegistration" element={<Layout><EventRegistrationForm /></Layout>}/>
        <Route path="/lodder" element={<Layout><Lodderr /></Layout>}/>
        <Route path="/certificates" element={<Layout><Certificates /></Layout>}/>
        <Route path="/OtherProfile" element={<Layout><OtherProfile /></Layout>}/>
        <Route path="/Chat" element={<Layout fillHeight><Chat /></Layout>}/>
        <Route path="/chat" element={<Layout fillHeight><Chat /></Layout>}/>
        <Route path="/recentMember" element={<Layout><RecntMember /></Layout>}/>
        <Route path="/WithdrawalForm" element={<Layout><WithdrawalForm /></Layout>}/>  
        <Route path="/invoice List" element={<Layout><Invoice /></Layout>}/>
        <Route path="/upload-invoices" element={<Layout><InvoicesPage /></Layout>}/>
        <Route path="/invoiceList" element={<Layout><InvoiceList /></Layout>}/>
        <Route path="/activeMember" element={<Layout><Activeuser /></Layout>}/>
        <Route path="/Help" element={<Layout><Help /></Layout>}/>
        <Route path="/memberinCountry" element={<Layout><MemberinCountry /></Layout>}/>
        <Route path="/branches" element={<Layout><BranchManagement /></Layout>}/>
        <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Route> 
      </Routes>
    </BrowserRouter>
   


  );
}

